<template>
  <div class="user-management-exccAuthorization">
    <p class="user-management-child-header b-1-cl a-3-bd">
      {{ $t("personal.exccAuthorization.title2") }}
    </p>
    <div class="loadinBox" v-if="isLoading">
      <c-loading size="60" />
    </div>
    <div v-else class="user-management-center">
      <div v-if="authLevel === 0 || active === '1'" class="audit-information">
        <svg class="icon icon-50" aria-hidden="true">
          <use xlink:href="#icon-g_3"></use>
        </svg>
        <p>{{ $t("personal.idAuth.wait")[0] }} <br />{{ $t("personal.idAuth.wait")[1] }}</p>
      </div>
      <div v-else>
        <p class="note b-7-cl">
          <svg class="icon icon-16" aria-hidden="true" style="marginright: 5px">
            <use xlink:href="#icon-c_2"></use>
          </svg>
          {{ $t("personal.exccAuthorization.title") }}
        </p>
        <div class="idAuth-center clearfix">
          <!-- 别名 -->
          <c-inputLine
            name="aliasname"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText1')"
            :errorHave="true"
            :disabled="true"
            :value="aliasname"
          >
          </c-inputLine>
          <!-- 性别 -->
          <c-inputLine
            name="sex"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText2')"
            :errorHave="true"
            :disabled="true"
            :value="sex"
          >
          </c-inputLine>
          <!-- 身份证/居住证/护照号码 -->
          <c-inputLine
            name="uinfin"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText3')"
            :errorHave="true"
            :disabled="true"
            :value="uinfin"
          >
          </c-inputLine>
          <!-- 全名 -->
          <c-inputLine
            name="name"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText4')"
            :errorHave="true"
            :disabled="true"
            :value="name"
          >
          </c-inputLine>
          <!-- 国籍 -->
          <c-inputLine
            name="nationality"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText5')"
            :errorHave="true"
            :disabled="true"
            :value="nationality"
          >
          </c-inputLine>
          <!-- 居留身份 -->
          <c-inputLine
            name="residentialstatus"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText6')"
            :errorHave="true"
            :disabled="true"
            :value="residentialstatus"
          >
          </c-inputLine>
          <!-- {{dob}}12 -->
          <!-- 出生日期 -->
          <c-inputLine
            name="dob"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText7')"
            :errorHave="true"
            :disabled="true"
            :value="dob"
          >
          </c-inputLine>
          <!-- 出生国家 -->
          <c-inputLine
            name="birthcountry"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText8')"
            :errorHave="true"
            :disabled="true"
            :value="birthcountry"
          >
          </c-inputLine>
          <!-- 注册地址 -->
          <c-inputLine
            name="regadd"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText9')"
            :errorHave="true"
            :disabled="true"
            :value="regadd"
          >
          </c-inputLine>
          <!-- 手机号码 -->
          <c-inputLine
            name="mobileno"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText10')"
            :errorHave="true"
            errorText=""
            maxLength="13"
            :value="mobileno"
            @onchanges="inputChanges"
          >
          </c-inputLine>
          <!-- 通信地址 -->
          <c-inputLine
            name="mailadd"
            inputType="text"
            :promptText="$t('personal.exccAuthorization.promptText11')"
            :errorHave="true"
            maxLength="50"
            :value="mailadd"
            @onchanges="inputChanges"
          >
          </c-inputLine>
          <!-- 收入来源 -->
          <c-select
            :filterable="true"
            :value="income"
            :promptText="$t('personal.exccAuthorization.promptText12')"
            @onChanges="incomeChange"
            name="income"
            :errorHave="true"
            :options="incomeList"
          />
          <!-- 您选择了其他收入来源，请描述 -->
          <c-inputLine
            v-if="income === '6'"
            name="qtTExt"
            inputType="text"
            :promptText="$t('personal.exccAuthForm.text15')"
            marginTop="0px"
            maxLength="256"
            :value="qtTExt"
            @onchanges="inputChanges"
          />
          <c-button
            type="solid"
            :big="true"
            className=""
            paddingW="0px"
            :disabled="disabled"
            marginTop="18px"
            height="40px"
            width="100%"
            @click="submitData()"
            >{{ $t("personal.exccAuthorization.submit") }}</c-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fixInput } from '@/utils';
import countryMinix from 'BlockChain-ui-privatization/PC/common-mixin/countryList/countryList';

export default {
  name: 'exccAuthorization',
  mixins: [countryMinix],
  components: {},
  data() {
    return {
      isLoading: true,
      aliasname: '',
      sex: '',
      uinfin: '',
      name: '',
      nationality: '',
      residentialstatus: '',
      dob: '',
      birthcountry: '',
      regadd: '',
      mobileno: '',
      mailadd: '',
      income: '0', // 收入来源
      code: '',
      active: '',
      qtTExt: '', // 收入来源选择其他的文案
    };
  },
  watch: {
    mobileno(val) {
      this.mobileno = fixInput(val, 0);
    },
    authRealname(authRealname) {
      if (authRealname !== null) {
        if (authRealname.text === 'success') {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'success' });
          this.active = '1';
        } else {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    dob(val) {
      if (val && this.ageLimit && !this.validateAge()) {
        this.$bus.$emit('tip', {
          text: `您需要年满${this.ageLimit}岁才能在平台认证`,
          type: 'error',
        });
      }
    },
  },
  computed: {
    exccKycConfig() {
      return this.$store.state.personal.exccKycConfig;
    },
    ageLimit() {
      return this.exccKycConfig ? Number(this.exccKycConfig.data.ageLimit) : 0;
    },
    authRealname() {
      return this.$store.state.personal.authRealname;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    authLevel() {
      return this.userInfo ? this.userInfo.authLevel : '';
    },
    disabled() {
      if (this.dob && !this.validateAge()) {
        return true;
      }
      if (this.income === '6' && !this.qtTExt) {
        return true;
      }
      return !(this.mobileno && this.mailadd);
    },
    // 收入来源列表
    incomeList() {
      return [
        { code: '0', value: this.$t('personal.exccAuthorization.income1') },
        { code: '1', value: this.$t('personal.exccAuthorization.income2') },
        { code: '2', value: this.$t('personal.exccAuthorization.income3') },
        { code: '3', value: this.$t('personal.exccAuthorization.income4') },
        { code: '4', value: this.$t('personal.exccAuthorization.income5') },
        { code: '5', value: this.$t('personal.exccAuthorization.income6') },
        { code: '6', value: this.$t('personal.exccAuthorization.income7') },
      ];
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.code = this.$route.query.code;
      if (this.code) {
        this.getData();
      }
      if (!this.exccKycConfig) {
        this.$store.dispatch('exccKycConfig');
      }
    },
    getData() {
      this.axios({
        url: '/kyc/singPass/getInfo',
        method: 'post',
        header: {},
        params: {
          code: this.code,
        },
      })
        .then((info) => {
          this.isLoading = false;
          if (info.code === '0') {
            if (info.data) {
              this.aliasname = info.data.aliasname;
              this.sex = info.data.sex;
              this.uinfin = info.data.uinfin;
              this.name = info.data.name;
              this.nationality = info.data.nationality;
              this.residentialstatus = info.data.residentialstatus;
              this.dob = info.data.dob;
              this.birthcountry = info.data.birthcountry;
              this.regadd = info.data.regadd;
              this.mobileno = info.data.mobileno;
              this.mailadd = info.data.mailadd;
              this.qtTExt = info.data.otherIncomeDesc;
              this.income = '0';
            }
          } else {
            this.$bus.$emit('tip', { text: info.msg, type: 'error' });
          }
        })
        .catch(() => {});
    },
    inputChanges(value, name) {
      this[name] = value.trim();
    },
    incomeChange(item) {
      this.income = item.code;
    },
    submitData() {
      const info = {
        mobileno: this.mobileno,
        mailadd: this.mailadd,
        income: this.income,
        otherIncomeDesc: this.qtTExt,
      };
      this.$store.dispatch('singPassVerifyAuth', info);
    },
    validateAge() {
      if (!this.ageLimit) {
        return true;
      }
      const birthday1 = this.dob.split('-');
      const convert2Date = new Date(birthday1[0], birthday1[1], birthday1[2]);
      let nowDate = new Date(); // 获取当前时间
      const year = nowDate.getFullYear();
      const month = nowDate.getMonth() + 1;
      const date = nowDate.getDate();
      nowDate = new Date(year, month, date);
      const age = nowDate.getTime() - convert2Date.getTime(); // 毫秒
      let leapYear = 0; // 有多少个闰年
      for (let i = 0; i <= this.ageLimit; i += 1) {
        if ((i % 4 === 0 && i % 100 !== 0) || i % 400 === 0) {
          leapYear += 1;
        }
      }
      const YearNumber = this.ageLimit - leapYear;
      const betweenNumer = 86400000 * 365 * YearNumber + 86400000 * 366 * leapYear;
      return age >= betweenNumer;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-management-exccAuthorization {
  width: 100%;
  padding-bottom: 50px;
  .user-management-child-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }

  .user-management-center i {
    width: 14px;
  }

  .certification-process {
    margin: 40px 95px;
    position: relative;
    text-align: center;
  }

  .certification-process div p {
    font-size: 14px;
    line-height: 24px;
  }

  .step-left {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding-right: 10px;
  }

  .step-center {
    display: inline-block;
    position: relative;
    z-index: 2;
    padding: 0 10px;
  }

  .step-right {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding-left: 10px;
  }

  .certification-process .div-line {
    width: 100%;
    position: absolute;
    left: 0;
    top: 11px;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    z-index: 1;
  }

  .span-mark {
    float: left;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
    margin-right: 10px;
  }

  .idAuth-center {
    float: left;
    width: 380px;
    margin: 0 300px;
    padding-bottom: 100px;
  }

  .upload1,
  .upload2,
  .upload3 {
    float: left;
  }

  .upload1 div.upload1-left,
  .upload2 div.upload2-left,
  .upload3 div.upload2-left,
  .upload1 div.upload1-right,
  .upload2 div.upload2-right,
  .upload3 div.upload2-right {
    width: 180px;
    height: 120px;
    float: left;
    box-sizing: border-box;
    border-radius: 2px;
  }

  .upload1 div.upload1-left,
  .upload2 div.upload2-left,
  .upload3 div.upload2-left {
    border-width: 1px;
    border-style: dashed;
    margin-right: 20px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    svg {
      margin: 40px 78px 10px 78px;
    }

    p {
      font-size: 12px;
      text-align: center;
      padding: 0 5px;
    }

    .mmd-loading-circle-right,
    .mmd-loading-circle-left {
      border-color: rgba(27, 170, 236, 1);
    }

    .loading-Img {
      position: absolute;
      z-index: 2;
    }

    .loading-img {
      width: 180px;
      height: 120px;
      margin: 0;
    }

    .loading-mc {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;

      div {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.7;
      }
    }
  }

  .upload2,
  .upload3 {
    margin-top: 20px;
  }

  .upload-text {
    float: left;
    font-size: 12px;
    line-height: 20px;
    margin-top: 34px;
    margin-bottom: 26px;
  }

  .upload_file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 3;
  }

  .common-button-loading {
    position: absolute;
    vertical-align: middle;
    left: 50%;
    margin-left: -17px;
    top: 45px;
    transform: translateY(-50%);
  }

  .loading-text {
    margin-top: 70px;
  }

  .audit-information {
    text-align: center;

    svg {
      margin: 80px 0 15px 0;
    }
  }

  .audit-information p {
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }
  .loadinBox {
    text-align: center;
    padding-top: 200px;
  }
  .note {
    margin: 20px 0 40px 15px;
  }
}
</style>
